export default __webpack_public_path__ + "static/media/collectibles-val.e6479cc3.jfif";